import { useState, useEffect, useRef } from "react";
import emailjs from "@emailjs/browser";
import profilePic from "./assets/profile.png";
// Add your decoration images here
import decorationImage1 from "./assets/decoration1.png"; // Replace with your first photo
import decorationImage2 from "./assets//decoration2.png"; // Replace with your second photo
import Hero from "./assets//heroConsulven.png";
import About from "./assets//aboutConsulven.png";
import FooterMockup from "./assets//footerConsulven.png";
import PC1 from "./assets//HeroPrime.png"
import PC2 from "./assets//AboutPrime.png";
import PC3 from "./assets//ContactPrime.png";
import QQH01 from "./assets//QQH-01.png";
import QQH02 from "./assets//QQH-02.png";
import QQH03 from "./assets//QQH-03.png";
import AnburFur1 from "./assets//AnbuFur-Hero.png";
import AnburFur2 from "./assets//AnbuFur-01.png";
import AnburFur3 from "./assets//anbufur-2.png";
import fp1 from "./assets//fp1.jpeg";
import fp2 from "./assets//fp02.jpg";
import fp3 from "./assets//fp03.jpg";
import LP1 from "./assets//AK.jpeg";
import LP2 from "./assets//ELS.jpeg";
import LP3 from "./assets//DCP.png";

const typewriterText = "Designing Products That Solve Real Problems & Drive Business Growth";

const websiteProjects = [
  {
    id:"01", 
    title:"Consulven", 
    category:"Website Design",
    color:"#2563EB", 
    tags:["Web Design", "UX Strategy", "Enterprise"],
    status:"COMPLETED",
    client:"Consulven IFSC", 
    role:"Product Designer", 
    tools:"Figma, UX Research, Strategy", 
    year:"2024",
    duration:"2 months",
    overview:"Designed a comprehensive digital presence for an international advisory firm, focusing on credibility, compliance communication, and enterprise trust.",
    challenge:"The client needed a professional digital presence that would communicate credibility and compliance expertise to international clients. The existing website lacked structure and failed to build trust with potential enterprise customers.",
    approach:"Conducted stakeholder interviews and competitive analysis to understand the compliance advisory space. Created user personas for international business clients. Developed information architecture that prioritized clarity and trust-building. Designed a visual system that balanced professionalism with approachability.",
    solution:"Rebuilt website UX from ground up with structured navigation, clear compliance messaging, and enterprise-focused design language. Implemented intuitive information architecture and professional visual identity that resonated with C-level decision makers.",
    impact:[
      "Successfully established digital positioning in competitive market",
      "Improved user trust scores by 45% based on user testing",
      "Clear communication of compliance expertise reduced support queries by 30%",
      "Enhanced professional brand perception led to 25% increase in qualified leads"
    ],
    metrics:{
      userSatisfaction: "45%",
      leadIncrease: "25%",
      supportReduction: "30%"
    },
    websiteUrl:"https://consulvenifsc.com/",
    behanceUrl:"https://www.behance.net/gallery/230230983/Consulven-Consulting-Website-UIUX-Design",
    mockups:[{label:"Hero Section",src:Hero},{label:"About Page",src:About},{label:"Footer Design",src:FooterMockup}],
  },
  {
    id:"02", 
    title:"Prime Counsel", 
    category:"Website Design",
    color:"#7C3AED", 
    tags:["Web Design", "Legal Tech", "UX Redesign"],
    status:"COMPLETED",
    client:"Prime Counsel Solution", 
    role:"Lead Product Designer", 
    tools:"Figma, Illustrator, Photoshop, User Testing", 
    year:"2024",
    duration:"3 months",
    overview:"Modernized a legacy legal platform with comprehensive UX overhaul, combining classic legal aesthetics with modern usability standards.",
    challenge:"Legacy legal website suffered from poor usability and outdated interface. Users struggled with complex navigation and the site failed to communicate professional authority effectively. High bounce rates indicated users couldn't find information quickly.",
    approach:"Conducted user research with both lawyers and clients to understand pain points. Mapped user journeys for key tasks. Created wireframes and prototypes, iterating based on usability testing. Developed a design system that honored legal tradition while embracing modern UX principles.",
    solution:"Redesigned into structured, user-focused system with antique-inspired legal aesthetic combined with modern usability standards. Implemented clear navigation hierarchy, improved content organization, and streamlined task flows for common user goals.",
    impact:[
      "Navigation clarity improved - task completion time reduced by 40%",
      "Brand authority strengthened with 60% increase in time on site",
      "Modern usability with classic legal aesthetics maintained brand identity",
      "Successful deployment with 92% positive user feedback"
    ],
    metrics:{
      taskCompletion: "40%",
      timeOnSite: "60%",
      userFeedback: "92%"
    },
    websiteUrl:"https://www.figma.com/proto/gHIhokLPZpAf1NQuBX8mwD/PRIME-COUNSEL?page-id=2622%3A17330&node-id=2622-20118&viewport=711%2C301%2C0.05&t=qZzAeEl1w1ARDyCM-1&scaling=scale-down&content-scaling=fixed&starting-point-node-id=2622%3A21184",
    behanceUrl:"https://www.behance.net/gallery/230103201/Ancient-Legal-Web-Design?tracking_source=project_owner_other_projects",
    mockups:[{label:"Login Portal",src:PC1},{label:"Dashboard",src:PC2},{label:"Records View",src:PC3}],
  },
  {
    id:"03", 
    title:"QuantumQuest Wealth", 
    category:"Website Design",
    color:"#059669", 
    tags:["Fintech", "Brand Design", "UX Strategy"],
    status:"COMPLETED",
    client:"QuantumQuest Wealth", 
    role:"Product Designer & Brand Strategist", 
    tools:"Figma, Photoshop, AI, User Research", 
    year:"2025",
    duration:"1 week",
    overview:"Created modern digital identity for investment advisory firm with focus on trust, credibility, and conversion optimization.",
    challenge:"Investment firm needed to establish digital credibility and trust with potential investors. Existing presence failed to communicate expertise and had poor conversion rates. Needed rapid turnaround to launch during market opportunity window.",
    approach:"Fast-tracked research with stakeholder workshops and competitive analysis. Created trust-focused design strategy emphasizing social proof and clear value proposition. Designed conversion-optimized flows with strategic CTA placement.",
    solution:"Designed high-trust financial interface with structured UX flow, clear service architecture, strategic testimonial placement, and optimized conversion CTAs throughout the user journey. Created cohesive brand identity that communicates stability and expertise.",
    impact:[
      "User engagement metrics increased by 65% week over week",
      "Investor confidence reinforced - 40% increase in consultation bookings",
      "Successful system launch with zero critical issues",
      "Lead conversion rates improved by 35%"
    ],
    metrics:{
      engagement: "65%",
      conversions: "35%",
      bookings: "40%"
    },
    websiteUrl:"https://www.figma.com/proto/XUMSBZvykv8g1BT424pB4R/QuantunQuest-Wealth?node-id=1-2030&viewport=219%2C59%2C0.04&t=LrY4kvU4vSj0N1Yn-1&scaling=scale-down&content-scaling=fixed&page-id=1%3A3",
    behanceUrl:"https://www.behance.net/gallery/229369907/Modern-UIUX-for-Financial-Advisory/modules/1314047951",
    mockups:[{label:"Hero Section",src:QQH01},{label:"Services",src:QQH02},{label:"Contact Flow",src:QQH03}],
  },
  {
    id:"04",
    title:"ELS Legal",
    category:"Website Design",
    color:"#DC2626",
    tags:["Web Design", "Legal Services", "Responsive"],
    status:"COMPLETED",
    client:"ELS Legal",
    role:"Product Designer & Brand Designer",
    tools:"Figma, Photoshop, Illustrator, User Testing",
    year:"2024-2025",
    duration:"2 months",
    overview:"Designed responsive legal services website focused on clear service presentation, trust-building, and mobile-first user experience.",
    challenge:"The website needed a professional legal identity, clear information hierarchy, and mobile-friendly navigation. Previous site had high mobile bounce rates and unclear service offerings that confused potential clients.",
    approach:"Conducted user interviews with existing clients to understand decision-making process. Analyzed mobile usage patterns and created mobile-first design strategy. Developed information architecture prioritizing service clarity and easy contact access.",
    solution:"Created clean responsive website with structured legal content sections, strong call-to-action placement, and trust-focused visual style. Applied mobile-first approach ensuring smooth browsing on all devices. Implemented progressive disclosure to manage information complexity.",
    impact:[
      "Improved website clarity reduced bounce rate by 38%",
      "Stronger professional brand presentation increased referrals by 22%",
      "Mobile responsiveness led to 55% increase in mobile conversions",
      "Enhanced user engagement with 45% longer average session duration"
    ],
    metrics:{
      bounceRate: "38%",
      mobileConversions: "55%",
      sessionDuration: "45%"
    },
    websiteUrl:"https://www.figma.com/proto/AWymbf5PAPNilmAtKYe2yZ/ELS-LEGAL?node-id=1-4489&viewport=-44%2C-367%2C0.05&t=cbRxiOyisFr0Zw6y-1&scaling=scale-down&content-scaling=fixed&page-id=0%3A1",
    behanceUrl:"https://www.behance.net/gallery/230103201/Ancient-Legal-Web-Design?tracking_source=project_owner_other_projects",
    mockups:[{label:"Mockup",src:fp1},{label:"Homepage",src:fp2},{label:"Services",src:fp3}]
  },
  {
    id:"05", 
    title:"AnbuFur", 
    category:"Full-Stack Development",
    color:"#F59E0B", 
    tags:["Full-Stack", "Social Impact", "Platform Design"],
    status:"LIVE",
    client:"AnbuFur", 
    role:"Product Designer & Full-Stack Developer",
    tools:"React, TypeScript, Supabase, Tailwind CSS, Figma", 
    year:"2025",
    duration:"2 weeks",
    overview:"Built end-to-end animal rescue & adoption platform serving Tamil Nadu's animal welfare community with real-time features and streamlined processes.",
    challenge:"Tamil Nadu's animal welfare community lacked a centralized platform for rescue coordination, adoption processes, and volunteer management. Fragmented communication led to delayed rescues, poor adoption rates, and volunteer coordination issues. Needed rapid development with limited resources.",
    approach:"Conducted rapid user research with animal welfare organizations. Designed MVP feature set focusing on core user needs. Created intuitive flows for time-critical rescue scenarios. Built scalable architecture supporting real-time updates and community engagement.",
    solution:"Built full-stack platform with real-time rescue feed, streamlined 3-step adoption flow, volunteer marketplace, and vet clinic directory. Implemented responsive design ensuring accessibility across devices. Rapid development cycle delivered complete solution from concept to live in 2 weeks.",
    impact:[
      "End-to-end platform launched successfully serving 500+ users in first month",
      "Active community serving Tamil Nadu animal welfare organizations",
      "Real-time rescue coordination reduced response time by 60%",
      "Streamlined adoption process increased successful adoptions by 40%"
    ],
    metrics:{
      responseTime: "60%",
      adoptions: "40%",
      activeUsers: "500+"
    },
    websiteUrl:"https://anbu-fur.netlify.app/",
    behanceUrl:"https://www.behance.net/gallery/244613911/AnbuFur-Animal-Rescue-Adoption-Platform",
    mockups:[{label:"Adoption Flow",src:AnburFur1},{label:"Community Feed",src:AnburFur2},{label:"Volunteer Portal",src:AnburFur3}],
  },
];

const brandIdentityWork = [
  {
    id:"brand-01",
    title:"AK's Cafe Point",
    type:"Logo Design",
    description:"Mascot-led logo design for cafe showcased in Instagram mockup format",
    image:LP1,
    category:"Hospitality"
  },
  {
    id:"brand-02",
    title:"ELS Legal",
    type:"Logo Design",
    description:"Professional legal branding with outdoor lightbox signage",
    image:LP2,
    category:"Legal"
  },
  {
    id:"brand-03",
    title:"DCP Dream Cut Pictures",
    type:"Logo Design",
    description:"Cinematic logo identity for video production company",
    image:LP3,
    category:"Media"
  },
];

const timeline = [
  { 
    year:"2024-2025", 
    title:"Product Designer", 
    place:"BFC MEDIA PVT LMT", 
    desc:"Led end-to-end product design for web and mobile applications. Conducted user research, created design systems, and collaborated with cross-functional teams to deliver user-centered solutions that drove business growth.",
    skills:["Product Strategy", "User Research", "Design Systems", "Stakeholder Management"]
  },
  { 
    year:"2022-2023", 
    title:"Sr Customer Support Associate", 
    place:"Teleperformance", 
    desc:"Handled complex customer queries and e-commerce issues. Developed deep understanding of user pain points and behavior patterns that inform my product design approach. Managed high-priority cases with focus on user satisfaction.",
    skills:["User Empathy", "Problem Solving", "Communication", "Customer Journey Analysis"]
  },
];

const education = [
  { 
    year:"2024–2026", 
    degree:"MBA-HR", 
    field:"Master of Business Administration — Human Resources", 
    institution:"University of Madras", 
    badge:"PURSUING",
    focus:"Organizational behavior, strategic management, and business leadership"
  },
  { 
    year:"2023–2024", 
    degree:"Full-stack Development", 
    field:"Professional Certificate", 
    institution:"Innovate Technology", 
    badge:"COMPLETED",
    focus:"React, Node.js, database design, and modern web development"
  },
  { 
    year:"2019–2022", 
    degree:"BCA", 
    field:"Bachelor of Computer Applications", 
    institution:"St. Peters Institute of Higher Education and Research", 
    badge:"GRADUATED",
    focus:"Computer science fundamentals, programming, and software development"
  },
];

function useWindowWidth() {
  const [w, setW] = useState(typeof window !== "undefined" ? window.innerWidth : 1200);
  useEffect(() => {
    const h = () => setW(window.innerWidth);
    window.addEventListener("resize", h);
    return () => window.removeEventListener("resize", h);
  }, []);
  return w;
}

function SectionLabel({ children }) {
  return (
    <div style={{ display:"flex", alignItems:"center", gap:16, marginBottom:16 }}>
      <span style={{ 
        fontFamily:"'Inter', -apple-system, BlinkMacSystemFont, sans-serif", 
        color:"#00897B", 
        letterSpacing:3, 
        textTransform:"uppercase", 
        fontWeight:700, 
        fontSize:14
      }}>
        {children}
      </span>
      <div style={{ flex:1, height:2, background:"linear-gradient(to right, #00897B, transparent)" }} />
    </div>
  );
}

function Footer() {
  const w = useWindowWidth();
  const isMobile = w < 600;
  
  return (
    <footer style={{ 
      background:"#F8F9FA", 
      borderTop:"2px solid #E9ECEF",
      padding:isMobile?"48px 20px":"64px 32px"
    }}>
      <div style={{ maxWidth:1200, margin:"0 auto" }}>
        <div style={{ 
          display:"grid", 
          gridTemplateColumns:isMobile?"1fr":"repeat(3, 1fr)", 
          gap:isMobile?40:48,
          marginBottom:48
        }}>
          <div>
            <h3 style={{ 
              fontFamily:"'Inter', sans-serif", 
              fontSize:24, 
              fontWeight:700, 
              color:"#1A1A1A", 
              marginBottom:8 
            }}>
              Gopika Krishna
            </h3>
            <p style={{ 
              fontFamily:"'Inter', sans-serif", 
              fontSize:14, 
              color:"#00897B",
              fontWeight:600,
              marginBottom:16
            }}>
              Product Designer
            </p>
            <p style={{ 
              fontFamily:"'Inter', sans-serif", 
              fontSize:14, 
              color:"#6C757D", 
              lineHeight:1.7,
              marginBottom:24
            }}>
              Crafting user-centered solutions that solve real problems and drive measurable business impact.
            </p>
            <div style={{ display:"flex", gap:12 }}>
              {[
                {href:"https://github.com/gopikaKrishnaaa", icon:"M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"},
                {href:"https://www.behance.net/gopikakrishvfc", icon:"M22 7h-7v-2h7v2zm1.726 10c-.442 1.297-2.029 3-5.101 3-3.074 0-5.564-1.729-5.564-5.675 0-3.91 2.325-5.92 5.466-5.92 3.082 0 4.964 1.782 5.375 4.426.078.506.109 1.188.095 2.14h-8.027c.13 3.211 3.483 3.312 4.588 2.029h3.168zm-7.686-4h4.965c-.105-1.547-1.136-2.219-2.477-2.219-1.466 0-2.277.768-2.488 2.219zm-9.574 6.988h-6.466v-14.967h6.953c5.476.081 5.58 5.444 2.72 6.906 3.461 1.26 3.577 8.061-3.207 8.061zm-3.466-8.988h3.584c2.508 0 2.906-3-.312-3h-3.272v3zm3.391 3h-3.391v3.016h3.341c3.055 0 2.868-3.016.05-3.016z"},
                {href:"https://www.linkedin.com/in/gopika-krishz/", icon:"M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"}
              ].map(({href, icon}, i) => (
                <a key={i} href={href} target="_blank" rel="noopener noreferrer"
                  style={{ 
                    width:40, 
                    height:40, 
                    background:"#FFF", 
                    border:"2px solid #E9ECEF",
                    borderRadius:8, 
                    display:"flex", 
                    alignItems:"center", 
                    justifyContent:"center",
                    transition:"all 0.3s"
                  }}
                  onMouseEnter={e => {
                    e.currentTarget.style.borderColor="#00897B";
                    e.currentTarget.style.transform="translateY(-2px)";
                  }}
                  onMouseLeave={e => {
                    e.currentTarget.style.borderColor="#E9ECEF";
                    e.currentTarget.style.transform="translateY(0)";
                  }}>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="#00897B">
                    <path d={icon}/>
                  </svg>
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 style={{ 
              fontFamily:"'Inter', sans-serif", 
              fontSize:16, 
              fontWeight:600, 
              color:"#1A1A1A", 
              marginBottom:20 
            }}>
              Quick Links
            </h4>
            {["About", "Skills", "Work", "Projects", "Contact"].map(link => (
              <a key={link} href={`#${link.toLowerCase()}`}
                style={{ 
                  display:"block", 
                  fontFamily:"'Inter', sans-serif", 
                  fontSize:14, 
                  color:"#6C757D", 
                  textDecoration:"none",
                  marginBottom:12,
                  transition:"color 0.3s"
                }}
                onMouseEnter={e => e.currentTarget.style.color="#00897B"}
                onMouseLeave={e => e.currentTarget.style.color="#6C757D"}>
                {link}
              </a>
            ))}
          </div>

          <div>
            <h4 style={{ 
              fontFamily:"'Inter', sans-serif", 
              fontSize:16, 
              fontWeight:600, 
              color:"#1A1A1A", 
              marginBottom:20 
            }}>
              Get In Touch
            </h4>
            <div style={{ 
              fontFamily:"'Inter', sans-serif", 
              fontSize:14, 
              color:"#6C757D", 
              lineHeight:1.8
            }}>
              <p style={{ marginBottom:12, display:"flex", alignItems:"center", gap:8 }}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#00897B" strokeWidth="2">
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                  <polyline points="22,6 12,13 2,6"/>
                </svg>
                gopikakrishna3081@gmail.com
              </p>
              <p style={{ marginBottom:12, display:"flex", alignItems:"center", gap:8 }}>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#00897B" strokeWidth="2">
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
                  <circle cx="12" cy="10" r="3"/>
                </svg>
                Chennai, Tamil Nadu, India
              </p>
            </div>
          </div>
        </div>

        <div style={{ 
          borderTop:"2px solid #E9ECEF", 
          paddingTop:32, 
          textAlign:"center" 
        }}>
          <p style={{ 
            fontFamily:"'Inter', sans-serif", 
            fontSize:14, 
            color:"#ADB5BD",
            margin:0
          }}>
            © 2026 Gopika Krishna. Product Designer Portfolio. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}

function ProjectCard({ project, onClick, isMobile }) {
  const [isHover, setIsHover] = useState(false);
  
  return (
    <div
      onClick={onClick}
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
      style={{
        background:"#FFF",
        borderRadius:16,
        overflow:"hidden",
        cursor:"pointer",
        transition:"all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
        border:"2px solid #E9ECEF",
        transform:isHover&&!isMobile?"translateY(-8px)":"translateY(0)",
        boxShadow:isHover
          ?"0 20px 40px rgba(0, 0, 0, 0.1), 0 0 0 2px #00BFA5"
          :"0 4px 12px rgba(0, 0, 0, 0.05)"
      }}>
      <div style={{ 
        position:"relative", 
        paddingTop:"56.25%", 
        background:"#F8F9FA",
        overflow:"hidden"
      }}>
        {project.mockups[0]?.src && (
          <img 
            src={project.mockups[0].src} 
            alt={project.title}
            style={{
              position:"absolute",
              top:0,
              left:0,
              width:"100%",
              height:"100%",
              objectFit:"cover",
              transition:"transform 0.4s",
              transform:isHover?"scale(1.05)":"scale(1)"
            }}
          />
        )}
        <div style={{
          position:"absolute",
          top:16,
          right:16,
          padding:"6px 14px",
          background:project.status==="LIVE"?"#28A745":"#00897B",
          color:"#FFF",
          borderRadius:20,
          fontFamily:"'Inter', sans-serif",
          fontSize:11,
          fontWeight:600,
          letterSpacing:0.5
        }}>
          {project.status}
        </div>
        <div style={{
          position:"absolute",
          top:16,
          left:16,
          padding:"6px 14px",
          background:"rgba(255, 255, 255, 0.95)",
          backdropFilter:"blur(8px)",
          color:"#1A1A1A",
          borderRadius:8,
          fontFamily:"'Inter', sans-serif",
          fontSize:11,
          fontWeight:600
        }}>
          {project.category}
        </div>
      </div>

      <div style={{ padding:isMobile?20:24 }}>
        <h3 style={{
          fontFamily:"'Inter', sans-serif",
          fontSize:isMobile?20:24,
          fontWeight:700,
          color:"#1A1A1A",
          marginBottom:12,
          lineHeight:1.3
        }}>
          {project.title}
        </h3>

        <p style={{
          fontFamily:"'Inter', sans-serif",
          fontSize:14,
          color:"#6C757D",
          lineHeight:1.7,
          marginBottom:20
        }}>
          {project.overview.substring(0, 100)}...
        </p>

        <div style={{
          display:"flex",
          alignItems:"center",
          justifyContent:"space-between",
          paddingTop:16,
          borderTop:"2px solid #F8F9FA"
        }}>
          <div style={{
            display:"flex",
            gap:6,
            flexWrap:"wrap"
          }}>
            {project.tags.slice(0, 2).map((tag, i) => (
              <span key={i} style={{
                padding:"4px 10px",
                background:"#E7F5F4",
                color:"#00897B",
                borderRadius:6,
                fontFamily:"'Inter', sans-serif",
                fontSize:11,
                fontWeight:600
              }}>
                {tag}
              </span>
            ))}
          </div>

          <svg 
            width="20" 
            height="20" 
            viewBox="0 0 24 24" 
            fill="none" 
            stroke="#00897B" 
            strokeWidth="2"
            style={{
              transition:"transform 0.3s",
              transform:isHover?"translateX(4px)":"translateX(0)"
            }}>
            <line x1="5" y1="12" x2="19" y2="12"/>
            <polyline points="12 5 19 12 12 19"/>
          </svg>
        </div>
      </div>
    </div>
  );
}

function BrandCard({ item, isMobile }) {
  const [isHover, setIsHover] = useState(false);
  
  return (
    <div
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
      style={{
        background:"#FFF",
        borderRadius:16,
        overflow:"hidden",
        transition:"all 0.3s",
        border:"2px solid #E9ECEF",
        transform:isHover&&!isMobile?"translateY(-4px)":"translateY(0)",
        boxShadow:isHover
          ?"0 12px 24px rgba(0, 0, 0, 0.08)"
          :"0 4px 12px rgba(0, 0, 0, 0.05)"
      }}>
      <div style={{
        position:"relative",
        paddingTop:"75%",
        background:"#F8F9FA",
        overflow:"hidden"
      }}>
        <img 
          src={item.image}
          alt={item.title}
          style={{
            position:"absolute",
            top:0,
            left:0,
            width:"100%",
            height:"100%",
            objectFit:"cover"
          }}
        />
        <div style={{
          position:"absolute",
          top:12,
          right:12,
          padding:"4px 10px",
          background:"rgba(255, 255, 255, 0.95)",
          borderRadius:6,
          fontFamily:"'Inter', sans-serif",
          fontSize:10,
          fontWeight:600,
          color:"#00897B"
        }}>
          {item.category}
        </div>
      </div>
      <div style={{ padding:20 }}>
        <h4 style={{
          fontFamily:"'Inter', sans-serif",
          fontSize:18,
          fontWeight:700,
          color:"#1A1A1A",
          marginBottom:8
        }}>
          {item.title}
        </h4>
        <p style={{
          fontFamily:"'Inter', sans-serif",
          fontSize:13,
          color:"#6C757D",
          lineHeight:1.6,
          margin:0
        }}>
          {item.description}
        </p>
      </div>
    </div>
  );
}

function ProjectPage({ project, onBack, onNext, nextProject }) {
  const [activeTab, setActiveTab] = useState("overview");
  const w = useWindowWidth();
  const isMobile = w < 600;

  useEffect(() => {
    window.scrollTo({top:0, behavior:"smooth"});
  }, [project.id]);

  const tabs = [
    {id:"overview", label:"Overview"},
    {id:"challenge", label:"Challenge"},
    {id:"approach", label:"Approach"},
    {id:"solution", label:"Solution"},
    {id:"impact", label:"Impact"}
  ];

  return (
    <div style={{ 
      background:"#FFFFFF", 
      minHeight:"100vh", 
      paddingTop:80 
    }}>
      <div style={{ maxWidth:1200, margin:"0 auto", padding:isMobile?"32px 20px":"64px 32px" }}>
        <button
          onClick={onBack}
          style={{
            display:"flex",
            alignItems:"center",
            gap:8,
            padding:"12px 24px",
            background:"#FFF",
            border:"2px solid #E9ECEF",
            borderRadius:8,
            color:"#00897B",
            fontFamily:"'Inter', sans-serif",
            fontSize:14,
            fontWeight:600,
            cursor:"pointer",
            marginBottom:40,
            transition:"all 0.3s"
          }}
          onMouseEnter={e => {
            e.currentTarget.style.borderColor="#00897B";
            e.currentTarget.style.transform="translateX(-4px)";
          }}
          onMouseLeave={e => {
            e.currentTarget.style.borderColor="#E9ECEF";
            e.currentTarget.style.transform="translateX(0)";
          }}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="19" y1="12" x2="5" y2="12"/>
            <polyline points="12 19 5 12 12 5"/>
          </svg>
          Back to Projects
        </button>

        <div style={{ marginBottom:48 }}>
          <div style={{ display:"flex", alignItems:"center", gap:12, marginBottom:16, flexWrap:"wrap" }}>
            <div style={{
              padding:"6px 16px",
              background:"#E7F5F4",
              border:"2px solid #B2DFDB",
              color:"#00897B",
              borderRadius:20,
              fontFamily:"'Inter', sans-serif",
              fontSize:12,
              fontWeight:600,
              letterSpacing:0.5
            }}>
              {project.category}
            </div>
            <div style={{
              padding:"6px 16px",
              background:project.status==="LIVE"?"#D4EDDA":"#E7F5F4",
              border:`2px solid ${project.status==="LIVE"?"#28A745":"#00BFA5"}`,
              color:project.status==="LIVE"?"#28A745":"#00897B",
              borderRadius:20,
              fontFamily:"'Inter', sans-serif",
              fontSize:12,
              fontWeight:600,
              letterSpacing:0.5
            }}>
              {project.status}
            </div>
          </div>

          <h1 style={{
            fontFamily:"'Inter', sans-serif",
            fontSize:isMobile?32:48,
            fontWeight:800,
            color:"#1A1A1A",
            marginBottom:24,
            lineHeight:1.2
          }}>
            {project.title}
          </h1>

          <div style={{
            display:"grid",
            gridTemplateColumns:isMobile?"1fr":"repeat(4, 1fr)",
            gap:24,
            marginBottom:32
          }}>
            {[
              {label:"Client", value:project.client},
              {label:"Role", value:project.role},
              {label:"Duration", value:project.duration},
              {label:"Year", value:project.year}
            ].map(item => (
              <div key={item.label} style={{
                background:"#F8F9FA",
                padding:20,
                borderRadius:12,
                border:"2px solid #E9ECEF"
              }}>
                <div style={{
                  fontFamily:"'Inter', sans-serif",
                  fontSize:12,
                  fontWeight:600,
                  color:"#00897B",
                  textTransform:"uppercase",
                  letterSpacing:1,
                  marginBottom:8
                }}>
                  {item.label}
                </div>
                <div style={{
                  fontFamily:"'Inter', sans-serif",
                  fontSize:15,
                  fontWeight:600,
                  color:"#1A1A1A",
                  lineHeight:1.4
                }}>
                  {item.value}
                </div>
              </div>
            ))}
          </div>

          <div style={{ display:"flex", gap:16, flexWrap:"wrap", marginBottom:32 }}>
            <a
              href={project.websiteUrl}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                padding:"14px 28px",
                background:"linear-gradient(135deg, #00BFA5 0%, #00897B 100%)",
                color:"#FFF",
                borderRadius:8,
                fontFamily:"'Inter', sans-serif",
                fontSize:14,
                fontWeight:600,
                textDecoration:"none",
                display:"inline-flex",
                alignItems:"center",
                gap:8,
                transition:"all 0.3s",
                boxShadow:"0 4px 12px rgba(0, 137, 123, 0.3)"
              }}
              onMouseEnter={e => {
                e.currentTarget.style.transform="translateY(-2px)";
                e.currentTarget.style.boxShadow="0 6px 20px rgba(0, 137, 123, 0.4)";
              }}
              onMouseLeave={e => {
                e.currentTarget.style.transform="translateY(0)";
                e.currentTarget.style.boxShadow="0 4px 12px rgba(0, 137, 123, 0.3)";
              }}>
              View Live Project
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/>
                <polyline points="15 3 21 3 21 9"/>
                <line x1="10" y1="14" x2="21" y2="3"/>
              </svg>
            </a>

            <a
              href={project.behanceUrl}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                padding:"14px 28px",
                background:"#FFF",
                border:"2px solid #E9ECEF",
                color:"#00897B",
                borderRadius:8,
                fontFamily:"'Inter', sans-serif",
                fontSize:14,
                fontWeight:600,
                textDecoration:"none",
                display:"inline-flex",
                alignItems:"center",
                gap:8,
                transition:"all 0.3s"
              }}
              onMouseEnter={e => {
                e.currentTarget.style.borderColor="#00897B";
                e.currentTarget.style.transform="translateY(-2px)";
              }}
              onMouseLeave={e => {
                e.currentTarget.style.borderColor="#E9ECEF";
                e.currentTarget.style.transform="translateY(0)";
              }}>
              Full Case Study
            </a>
          </div>

          {project.metrics && (
            <div style={{
              display:"grid",
              gridTemplateColumns:isMobile?"1fr":"repeat(3, 1fr)",
              gap:20,
              padding:isMobile?24:32,
              background:"#F8F9FA",
              borderRadius:12,
              border:"2px solid #E9ECEF",
              marginBottom:40
            }}>
              {Object.entries(project.metrics).map(([key, value]) => (
                <div key={key} style={{ textAlign:"center" }}>
                  <div style={{
                    fontSize:isMobile?32:40,
                    fontWeight:800,
                    color:"#00897B",
                    marginBottom:8,
                    fontFamily:"'Inter', sans-serif"
                  }}>
                    {value}
                  </div>
                  <div style={{
                    fontSize:13,
                    color:"#6C757D",
                    textTransform:"capitalize",
                    fontFamily:"'Inter', sans-serif",
                    fontWeight:500
                  }}>
                    {key.replace(/([A-Z])/g, ' $1').trim()}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        <div style={{
          display:"flex",
          gap:8,
          marginBottom:32,
          borderBottom:"2px solid #E9ECEF",
          overflowX:"auto",
          paddingBottom:0
        }}>
          {tabs.map(tab => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              style={{
                padding:"12px 24px",
                background:"none",
                border:"none",
                borderBottom:activeTab===tab.id?"3px solid #00897B":"3px solid transparent",
                color:activeTab===tab.id?"#00897B":"#6C757D",
                fontFamily:"'Inter', sans-serif",
                fontSize:14,
                fontWeight:600,
                cursor:"pointer",
                transition:"all 0.3s",
                whiteSpace:"nowrap"
              }}>
              {tab.label}
            </button>
          ))}
        </div>

        <div style={{
          background:"#F8F9FA",
          borderRadius:16,
          padding:isMobile?24:40,
          marginBottom:48,
          border:"2px solid #E9ECEF",
          minHeight:200
        }}>
          {activeTab === "overview" && (
            <div>
              <h3 style={{
                fontFamily:"'Inter', sans-serif",
                fontSize:24,
                fontWeight:700,
                color:"#1A1A1A",
                marginBottom:20
              }}>
                Project Overview
              </h3>
              <p style={{
                fontFamily:"'Inter', sans-serif",
                fontSize:16,
                color:"#495057",
                lineHeight:1.8
              }}>
                {project.overview}
              </p>
            </div>
          )}
          {activeTab === "challenge" && (
            <div>
              <h3 style={{
                fontFamily:"'Inter', sans-serif",
                fontSize:24,
                fontWeight:700,
                color:"#1A1A1A",
                marginBottom:20
              }}>
                The Challenge
              </h3>
              <p style={{
                fontFamily:"'Inter', sans-serif",
                fontSize:16,
                color:"#495057",
                lineHeight:1.8
              }}>
                {project.challenge}
              </p>
            </div>
          )}
          {activeTab === "approach" && (
            <div>
              <h3 style={{
                fontFamily:"'Inter', sans-serif",
                fontSize:24,
                fontWeight:700,
                color:"#1A1A1A",
                marginBottom:20
              }}>
                Design Approach
              </h3>
              <p style={{
                fontFamily:"'Inter', sans-serif",
                fontSize:16,
                color:"#495057",
                lineHeight:1.8
              }}>
                {project.approach}
              </p>
            </div>
          )}
          {activeTab === "solution" && (
            <div>
              <h3 style={{
                fontFamily:"'Inter', sans-serif",
                fontSize:24,
                fontWeight:700,
                color:"#1A1A1A",
                marginBottom:20
              }}>
                The Solution
              </h3>
              <p style={{
                fontFamily:"'Inter', sans-serif",
                fontSize:16,
                color:"#495057",
                lineHeight:1.8
              }}>
                {project.solution}
              </p>
            </div>
          )}
          {activeTab === "impact" && (
            <div>
              <h3 style={{
                fontFamily:"'Inter', sans-serif",
                fontSize:24,
                fontWeight:700,
                color:"#1A1A1A",
                marginBottom:20
              }}>
                Business Impact
              </h3>
              <ul style={{
                listStyle:"none",
                padding:0,
                margin:0
              }}>
                {project.impact.map((item, i) => (
                  <li key={i} style={{
                    display:"flex",
                    alignItems:"flex-start",
                    gap:16,
                    marginBottom:20,
                    fontFamily:"'Inter', sans-serif",
                    fontSize:16,
                    color:"#495057",
                    lineHeight:1.8
                  }}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" style={{ flexShrink:0, marginTop:2 }}>
                      <circle cx="12" cy="12" r="10" fill="#E7F5F4"/>
                      <path d="M8 12l3 3 5-5" stroke="#00897B" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>

        <div style={{
          display:"grid",
          gridTemplateColumns:isMobile?"1fr":"repeat(3, 1fr)",
          gap:24,
          marginBottom:64
        }}>
          {project.mockups.map((mockup, i) => (
            <div key={i} style={{
              background:"#FFF",
              borderRadius:16,
              overflow:"hidden",
              border:"2px solid #E9ECEF"
            }}>
              <div style={{
                aspectRatio:"16/9",
                background:"#F8F9FA",
                position:"relative",
                overflow:"hidden"
              }}>
                {mockup.src ? (
                  <img 
                    src={mockup.src} 
                    alt={mockup.label}
                    style={{
                      width:"100%",
                      height:"100%",
                      objectFit:"cover"
                    }}
                  />
                ) : (
                  <div style={{
                    width:"100%",
                    height:"100%",
                    display:"flex",
                    alignItems:"center",
                    justifyContent:"center",
                    color:"#ADB5BD",
                    fontFamily:"'Inter', sans-serif"
                  }}>
                    Visual {i+1}
                  </div>
                )}
              </div>
              <div style={{
                padding:16,
                fontFamily:"'Inter', sans-serif",
                fontSize:14,
                fontWeight:600,
                color:"#1A1A1A"
              }}>
                {mockup.label}
              </div>
            </div>
          ))}
        </div>

        <div style={{
          display:"flex",
          justifyContent:"space-between",
          alignItems:"center",
          padding:"32px 0",
          borderTop:"2px solid #E9ECEF",
          gap:20,
          flexWrap:"wrap"
        }}>
          <button
            onClick={onBack}
            style={{
              display:"flex",
              alignItems:"center",
              gap:8,
              padding:"12px 24px",
              background:"#FFF",
              border:"2px solid #E9ECEF",
              borderRadius:8,
              color:"#00897B",
              fontFamily:"'Inter', sans-serif",
              fontSize:14,
              fontWeight:600,
              cursor:"pointer",
              transition:"all 0.3s"
            }}
            onMouseEnter={e => {
              e.currentTarget.style.borderColor="#00897B";
              e.currentTarget.style.transform="translateX(-4px)";
            }}
            onMouseLeave={e => {
              e.currentTarget.style.borderColor="#E9ECEF";
              e.currentTarget.style.transform="translateX(0)";
            }}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="19" y1="12" x2="5" y2="12"/>
              <polyline points="12 19 5 12 12 5"/>
            </svg>
            All Projects
          </button>

          <button
            onClick={onNext}
            style={{
              display:"flex",
              alignItems:"center",
              gap:12,
              padding:"16px 32px",
              background:"linear-gradient(135deg, #00BFA5 0%, #00897B 100%)",
              border:"none",
              borderRadius:8,
              color:"#FFF",
              fontFamily:"'Inter', sans-serif",
              fontSize:16,
              fontWeight:600,
              cursor:"pointer",
              transition:"all 0.3s",
              boxShadow:"0 4px 12px rgba(0, 137, 123, 0.3)"
            }}
            onMouseEnter={e => {
              e.currentTarget.style.transform="translateY(-2px)";
              e.currentTarget.style.boxShadow="0 6px 20px rgba(0, 137, 123, 0.4)";
            }}
            onMouseLeave={e => {
              e.currentTarget.style.transform="translateY(0)";
              e.currentTarget.style.boxShadow="0 4px 12px rgba(0, 137, 123, 0.3)";
            }}>
            <span>Next: {nextProject.title}</span>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="5" y1="12" x2="19" y2="12"/>
              <polyline points="12 5 19 12 12 19"/>
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
}

function HomePage({ onSelectProject }) {
  const [typed, setTyped] = useState("");
  const [menuOpen, setMenuOpen] = useState(false);
  const [submitStatus, setSubmitStatus] = useState("");
  const [projectTab, setProjectTab] = useState("websites");
  const iv = useRef(null);
  const w = useWindowWidth();
  const isMobile = w < 600;

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitStatus("sending");
    emailjs.sendForm("service_iijmuo8","template_i2g9qo9",e.target,"E_7Nfy2YOkCxvnaNG")
      .then(()=>{
        setSubmitStatus("success");
        setTimeout(()=>setSubmitStatus(""),3000);
        e.target.reset();
      })
      .catch(()=>{
        setSubmitStatus("error");
        setTimeout(()=>setSubmitStatus(""),3000);
      });
  };

  useEffect(()=>{
    let i=0;
    iv.current=setInterval(()=>{
      setTyped(typewriterText.slice(0,i));
      if(i++>typewriterText.length)clearInterval(iv.current);
    },50);
    return()=>clearInterval(iv.current);
  },[]);

  const navLinks=[
    {label:"About",id:"about"},
    {label:"Skills",id:"skills"},
    {label:"Work",id:"work"},
    {label:"Projects",id:"projects"},
    {label:"Contact",id:"contact"}
  ];
  
  const scrollTo=(id)=>{
    document.getElementById(id)?.scrollIntoView({behavior:"smooth"});
    setMenuOpen(false);
  };

  return (
    <div style={{ 
      fontFamily:"'Inter', -apple-system, BlinkMacSystemFont, sans-serif", 
      background:"#FFFFFF", 
      color:"#1A1A1A", 
      minHeight:"100vh" 
    }}>
      {/* Navigation */}
      <nav style={{ 
        position:"fixed", 
        top:0, 
        left:0, 
        right:0, 
        zIndex:100, 
        background:"rgba(255, 255, 255, 0.98)", 
        backdropFilter:"blur(12px)", 
        borderBottom:"2px solid #E9ECEF",
        padding:isMobile?"16px 20px":"20px 48px",
        boxShadow:"0 2px 8px rgba(0, 0, 0, 0.05)"
      }}>
        <div style={{ 
          maxWidth:1400, 
          margin:"0 auto", 
          display:"flex", 
          alignItems:"center", 
          justifyContent:"space-between" 
        }}>
          <div style={{ 
            fontFamily:"'Inter', sans-serif", 
            fontSize:20, 
            fontWeight:700, 
            color:"#1A1A1A",
            letterSpacing:-0.5
          }}>
            Gopika Krishna
          </div>

          {!isMobile && (
            <div style={{ display:"flex", gap:40 }}>
              {navLinks.map(({label,id})=>(
                <a key={id} 
                  href={`#${id}`} 
                  onClick={e=>{e.preventDefault();scrollTo(id);}}
                  style={{ 
                    color:"#6C757D", 
                    textDecoration:"none", 
                    fontWeight:500,
                    fontSize:15,
                    transition:"color 0.3s"
                  }}
                  onMouseEnter={e=>e.currentTarget.style.color="#00897B"}
                  onMouseLeave={e=>e.currentTarget.style.color="#6C757D"}>
                  {label}
                </a>
              ))}
            </div>
          )}

          {isMobile && (
            <button 
              onClick={()=>setMenuOpen(o=>!o)} 
              style={{ 
                background:"none", 
                border:"none", 
                color:"#1A1A1A", 
                fontSize:24,
                cursor:"pointer",
                padding:8
              }}>
              {menuOpen?"✕":"☰"}
            </button>
          )}
        </div>
      </nav>

      {isMobile && menuOpen && (
        <div style={{ 
          position:"fixed", 
          top:72, 
          left:0, 
          right:0, 
          zIndex:99, 
          background:"rgba(255, 255, 255, 0.98)", 
          backdropFilter:"blur(12px)",
          borderBottom:"2px solid #E9ECEF",
          padding:"20px",
          boxShadow:"0 4px 12px rgba(0, 0, 0, 0.05)"
        }}>
          {navLinks.map(({label,id})=>(
            <a key={id} 
              href={`#${id}`} 
              onClick={e=>{e.preventDefault();scrollTo(id);}}
              style={{ 
                display:"block", 
                color:"#6C757D", 
                textDecoration:"none", 
                padding:"16px 0",
                borderBottom:"1px solid #F8F9FA",
                fontWeight:500,
                fontSize:16
              }}>
              {label}
            </a>
          ))}
        </div>
      )}

      {/* Hero */}
      <section style={{ 
        minHeight:"100vh", 
        display:"flex", 
        alignItems:"center", 
        paddingTop:80,
        background:"linear-gradient(135deg, #F8F9FA 0%, #FFFFFF 100%)",
        position:"relative",
        overflow:"hidden"
      }}>
        <div style={{
          position:"absolute",
          top:"20%",
          right:"10%",
          width:400,
          height:400,
          background:"radial-gradient(circle, rgba(0, 191, 165, 0.08) 0%, transparent 70%)",
          borderRadius:"50%",
          filter:"blur(60px)",
          pointerEvents:"none"
        }}/>
        <div style={{
          position:"absolute",
          bottom:"10%",
          left:"5%",
          width:300,
          height:300,
          background:"radial-gradient(circle, rgba(0, 137, 123, 0.05) 0%, transparent 70%)",
          borderRadius:"50%",
          filter:"blur(60px)",
          pointerEvents:"none"
        }}/>

        <div style={{ 
          maxWidth:1200, 
          margin:"0 auto", 
          padding:isMobile?"0 20px":"0 48px",
          position:"relative",
          zIndex:1
        }}>
          <div style={{ 
            display:"grid", 
            gridTemplateColumns:isMobile?"1fr":"1.2fr 1fr", 
            gap:isMobile?40:64,
            alignItems:"center"
          }}>
            <div>
              <div style={{
                display:"inline-block",
                padding:"8px 20px",
                background:"#E7F5F4",
                border:"2px solid #B2DFDB",
                borderRadius:24,
                marginBottom:24
              }}>
                <span style={{
                  fontFamily:"'Inter', sans-serif",
                  fontSize:13,
                  fontWeight:600,
                  color:"#00897B",
                  letterSpacing:0.5
                }}>
                  PRODUCT DESIGNER
                </span>
              </div>

              <h1 style={{
                fontSize:isMobile?"clamp(32px, 8vw, 48px)":"clamp(40px, 5vw, 64px)",
                fontWeight:800,
                lineHeight:1.1,
                marginBottom:16,
                color:"#1A1A1A"
              }}>
                Gopika Krishna
              </h1>

              <div style={{
                minHeight:60,
                marginBottom:32
              }}>
                <p style={{
                  fontSize:isMobile?18:22,
                  color:"#495057",
                  lineHeight:1.6,
                  fontWeight:500
                }}>
                  {typed}
                  <span style={{
                    display:"inline-block",
                    width:3,
                    height:24,
                    background:"#00897B",
                    marginLeft:4,
                    animation:"blink 1s step-end infinite",
                    verticalAlign:"middle"
                  }}/>
                </p>
              </div>

              <p style={{
                fontSize:16,
                color:"#6C757D",
                lineHeight:1.8,
                marginBottom:32
              }}>
                I combine user research, business strategy, and visual design to create products that users love and businesses need.
              </p>

              <div style={{ display:"flex", gap:16, marginBottom:40, flexWrap:"wrap" }}>
                <a href="#projects" 
                  onClick={e=>{e.preventDefault();scrollTo("projects");}}
                  style={{
                    padding:"16px 32px",
                    background:"linear-gradient(135deg, #00BFA5 0%, #00897B 100%)",
                    color:"#FFF",
                    borderRadius:8,
                    textDecoration:"none",
                    fontWeight:600,
                    fontSize:15,
                    display:"inline-flex",
                    alignItems:"center",
                    gap:8,
                    transition:"all 0.3s",
                    boxShadow:"0 4px 12px rgba(0, 137, 123, 0.3)"
                  }}
                  onMouseEnter={e=>{
                    e.currentTarget.style.transform="translateY(-2px)";
                    e.currentTarget.style.boxShadow="0 6px 20px rgba(0, 137, 123, 0.4)";
                  }}
                  onMouseLeave={e=>{
                    e.currentTarget.style.transform="translateY(0)";
                    e.currentTarget.style.boxShadow="0 4px 12px rgba(0, 137, 123, 0.3)";
                  }}>
                  View My Work
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                    <line x1="5" y1="12" x2="19" y2="12"/>
                    <polyline points="12 5 19 12 12 19"/>
                  </svg>
                </a>

                <a href="#contact" 
                  onClick={e=>{e.preventDefault();scrollTo("contact");}}
                  style={{
                    padding:"16px 32px",
                    background:"#FFF",
                    border:"2px solid #E9ECEF",
                    color:"#00897B",
                    borderRadius:8,
                    textDecoration:"none",
                    fontWeight:600,
                    fontSize:15,
                    transition:"all 0.3s"
                  }}
                  onMouseEnter={e=>{
                    e.currentTarget.style.borderColor="#00897B";
                    e.currentTarget.style.transform="translateY(-2px)";
                  }}
                  onMouseLeave={e=>{
                    e.currentTarget.style.borderColor="#E9ECEF";
                    e.currentTarget.style.transform="translateY(0)";
                  }}>
                  Let's Connect
                </a>
              </div>

              <div style={{ display:"flex", gap:32, flexWrap:"wrap" }}>
                {[
                  {value:"6+", label:"Projects Delivered"},
                  {value:"2.5yr", label:"Experience"},
                  {value:"100%", label:"Client Satisfaction"}
                ].map(stat => (
                  <div key={stat.label}>
                    <div style={{
                      fontSize:28,
                      fontWeight:700,
                      color:"#00897B",
                      marginBottom:4
                    }}>
                      {stat.value}
                    </div>
                    <div style={{
                      fontSize:13,
                      color:"#6C757D",
                      fontWeight:500
                    }}>
                      {stat.label}
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {!isMobile && (
              <div style={{
                position:"relative",
                display:"flex",
                justifyContent:"center",
                alignItems:"center"
              }}>
                <div style={{
                  position:"relative",
                  width:320,
                  height:320
                }}>
                  <div style={{
                    position:"absolute",
                    inset:-20,
                    border:"3px solid #B2DFDB",
                    borderRadius:"50%",
                    animation:"spin 20s linear infinite"
                  }}/>
                  <div style={{
                    position:"absolute",
                    inset:-40,
                    border:"2px solid #E7F5F4",
                    borderRadius:"50%",
                    animation:"spin 30s linear reverse infinite"
                  }}/>

                  <div style={{
                    width:"100%",
                    height:"100%",
                    borderRadius:"50%",
                    background:"linear-gradient(135deg, #E7F5F4 0%, #B2DFDB 100%)",
                    padding:8,
                    position:"relative",
                    zIndex:2
                  }}>
                    <div style={{
                      width:"100%",
                      height:"100%",
                      borderRadius:"50%",
                      overflow:"hidden",
                      border:"4px solid #FFF"
                    }}>
                      <img 
                        src={profilePic} 
                        alt="Gopika Krishna"
                        style={{
                          width:"100%",
                          height:"100%",
                          objectFit:"cover"
                        }}
                      />
                    </div>
                  </div>

                  <div style={{
                    position:"absolute",
                    top:20,
                    right:-20,
                    padding:"8px",
                    background:"#FFF",
                    border:"2px solid #E9ECEF",
                    borderRadius:12,
                    animation:"float 3s ease-in-out infinite",
                    boxShadow:"0 4px 12px rgba(0, 0, 0, 0.05)",
                    width:56,
                    height:56,
                    display:"flex",
                    alignItems:"center",
                    justifyContent:"center"
                  }}>
                    <img 
                      src={decorationImage1} 
                      alt="Decoration 1"
                      style={{
                        width:"100%",
                        height:"100%",
                        objectFit:"cover",
                        borderRadius:8
                      }}
                    />
                  </div>

                  <div style={{
                    position:"absolute",
                    bottom:40,
                    left:-20,
                    padding:"8px",
                    background:"#FFF",
                    border:"2px solid #E9ECEF",
                    borderRadius:12,
                    animation:"float 3s ease-in-out 1.5s infinite",
                    boxShadow:"0 4px 12px rgba(0, 0, 0, 0.05)",
                    width:56,
                    height:56,
                    display:"flex",
                    alignItems:"center",
                    justifyContent:"center"
                  }}>
                    <img 
                      src={decorationImage2} 
                      alt="Decoration 2"
                      style={{
                        width:"100%",
                        height:"100%",
                        objectFit:"cover",
                        borderRadius:8
                      }}
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* About */}
      <section id="about" style={{ 
        padding:isMobile?"80px 20px":"120px 48px",
        background:"#FFFFFF"
      }}>
        <div style={{ maxWidth:1200, margin:"0 auto" }}>
          <SectionLabel>About Me</SectionLabel>
          
          <div style={{
            display:"grid",
            gridTemplateColumns:isMobile?"1fr":"1fr 1fr",
            gap:isMobile?40:64,
            alignItems:"start",
            marginTop:48
          }}>
            <div>
              <h2 style={{
                fontSize:isMobile?28:40,
                fontWeight:700,
                color:"#1A1A1A",
                marginBottom:24,
                lineHeight:1.2
              }}>
                Product Designer Who Bridges User Needs & Business Goals
              </h2>

              <p style={{
                fontSize:16,
                color:"#495057",
                lineHeight:1.8,
                marginBottom:24
              }}>
                I'm Gopika Krishna, a product designer who believes great design is invisible. My approach combines deep user research, strategic thinking, and visual craft to create products that solve real problems.
              </p>

              <p style={{
                fontSize:16,
                color:"#495057",
                lineHeight:1.8,
                marginBottom:32
              }}>
                With a background spanning customer support, design, and development, I bring a unique perspective that helps me understand users deeply and translate their needs into elegant solutions that drive business results.
              </p>

              <div style={{
                padding:24,
                background:"#E7F5F4",
                borderLeft:"4px solid #00897B",
                borderRadius:8,
                marginBottom:32
              }}>
                <p style={{
                  fontSize:18,
                  color:"#1A1A1A",
                  fontWeight:600,
                  fontStyle:"italic",
                  margin:0,
                  lineHeight:1.6
                }}>
                  "Every product tells a story. My job is to make sure it's a story users want to be part of."
                </p>
              </div>
            </div>

            <div style={{
              display:"grid",
              gridTemplateColumns:"1fr",
              gap:24
            }}>
              {[
                {
                  icon:"M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2",
                  title:"User-Centered Approach",
                  desc:"Every design decision starts with understanding user needs through research and testing"
                },
                {
                  icon:"M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z",
                  title:"Business Impact",
                  desc:"Creating solutions that deliver measurable results and drive growth"
                },
                {
                  icon:"M13 10V3L4 14h7v7l9-11h-7z",
                  title:"Rapid Execution",
                  desc:"From concept to launch in weeks, not months, without compromising quality"
                },
                {
                  icon:"M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4",
                  title:"Full-Stack Skills",
                  desc:"Combining design and development expertise to build end-to-end products"
                }
              ].map((item, i) => (
                <div key={i} style={{
                  padding:24,
                  background:"#F8F9FA",
                  borderRadius:12,
                  border:"2px solid #E9ECEF",
                  transition:"all 0.3s"
                }}
                onMouseEnter={e => {
                  e.currentTarget.style.borderColor="#00897B";
                  e.currentTarget.style.transform="translateY(-4px)";
                  e.currentTarget.style.boxShadow="0 8px 16px rgba(0, 0, 0, 0.08)";
                }}
                onMouseLeave={e => {
                  e.currentTarget.style.borderColor="#E9ECEF";
                  e.currentTarget.style.transform="translateY(0)";
                  e.currentTarget.style.boxShadow="none";
                }}>
                  <div style={{
                    width:48,
                    height:48,
                    background:"#E7F5F4",
                    borderRadius:10,
                    display:"flex",
                    alignItems:"center",
                    justifyContent:"center",
                    marginBottom:16
                  }}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#00897B" strokeWidth="2">
                      <path d={item.icon}/>
                    </svg>
                  </div>
                  <h4 style={{
                    fontSize:18,
                    fontWeight:600,
                    color:"#1A1A1A",
                    marginBottom:8
                  }}>
                    {item.title}
                  </h4>
                  <p style={{
                    fontSize:14,
                    color:"#6C757D",
                    lineHeight:1.6,
                    margin:0
                  }}>
                    {item.desc}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Skills - keeping existing structure but with light colors */}
      <section id="skills" style={{ 
        padding:isMobile?"80px 20px":"120px 48px",
        background:"#F8F9FA"
      }}>
        <div style={{ maxWidth:1200, margin:"0 auto" }}>
          <SectionLabel>Product Design Skills</SectionLabel>

          <p style={{
            fontSize:18,
            color:"#6C757D",
            marginBottom:48,
            marginTop:16
          }}>
            Full-stack product design capabilities from strategy to implementation
          </p>

          <div style={{
            display:"grid",
            gridTemplateColumns:isMobile?"1fr":"repeat(3, 1fr)",
            gap:32,
            marginBottom:48
          }}>
            {[
              {
                title:"Product Strategy",
                icon:"M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4",
                color:"#2563EB",
                skills:["User Research", "Competitive Analysis", "Product Roadmapping", "Stakeholder Management", "Business Strategy"]
              },
              {
                title:"UX Design",
                icon:"M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z",
                color:"#00897B",
                skills:["User Journey Mapping", "Information Architecture", "Wireframing", "Usability Testing", "Interaction Design"]
              },
              {
                title:"UI Design",
                icon:"M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zm0 0h12a2 2 0 002-2v-4a2 2 0 00-2-2h-2.343M11 7.343l1.657-1.657a2 2 0 012.828 0l2.829 2.829a2 2 0 010 2.828l-8.486 8.485M7 17h.01",
                color:"#7C3AED",
                skills:["Visual Design", "Design Systems", "Prototyping", "Responsive Design", "Micro-interactions"]
              }
            ].map((category, i) => (
              <div key={i} style={{
                background:"#FFF",
                borderRadius:16,
                padding:32,
                border:"2px solid #E9ECEF",
                transition:"all 0.3s"
              }}
              onMouseEnter={e => {
                e.currentTarget.style.transform="translateY(-4px)";
                e.currentTarget.style.borderColor=category.color;
                e.currentTarget.style.boxShadow="0 12px 24px rgba(0, 0, 0, 0.08)";
              }}
              onMouseLeave={e => {
                e.currentTarget.style.transform="translateY(0)";
                e.currentTarget.style.borderColor="#E9ECEF";
                e.currentTarget.style.boxShadow="none";
              }}>
                <div style={{
                  width:56,
                  height:56,
                  background:`${category.color}15`,
                  borderRadius:12,
                  display:"flex",
                  alignItems:"center",
                  justifyContent:"center",
                  marginBottom:20
                }}>
                  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke={category.color} strokeWidth="2">
                    <path d={category.icon}/>
                  </svg>
                </div>

                <h3 style={{
                  fontSize:20,
                  fontWeight:700,
                  color:"#1A1A1A",
                  marginBottom:20
                }}>
                  {category.title}
                </h3>

                <div style={{ display:"flex", flexDirection:"column", gap:12 }}>
                  {category.skills.map(skill => (
                    <div key={skill} style={{
                      display:"flex",
                      alignItems:"center",
                      gap:8
                    }}>
                      <div style={{
                        width:6,
                        height:6,
                        borderRadius:"50%",
                        background:category.color
                      }}/>
                      <span style={{
                        fontSize:14,
                        color:"#495057"
                      }}>
                        {skill}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>

          {/* Tools */}
          <div style={{
            background:"#FFF",
            borderRadius:16,
            padding:isMobile?32:48,
            border:"2px solid #E9ECEF"
          }}>
            <h3 style={{
              fontSize:24,
              fontWeight:700,
              color:"#1A1A1A",
              marginBottom:32,
              textAlign:"center"
            }}>
              Design & Development Tools
            </h3>

            <div style={{
              display:"grid",
              gridTemplateColumns:isMobile?"repeat(3, 1fr)":"repeat(6, 1fr)",
              gap:24
            }}>
              {[
                {src:"https://cdn.jsdelivr.net/gh/devicons/devicon/icons/figma/figma-original.svg", name:"Figma"},
                {src:"https://upload.wikimedia.org/wikipedia/commons/c/c2/Adobe_XD_CC_icon.svg", name:"Adobe XD"},
                {src:"https://upload.wikimedia.org/wikipedia/commons/a/af/Adobe_Photoshop_CC_icon.svg", name:"Photoshop"},
                {src:"https://upload.wikimedia.org/wikipedia/commons/f/fb/Adobe_Illustrator_CC_icon.svg", name:"Illustrator"},
                {src:"https://cdn.jsdelivr.net/gh/devicons/devicon/icons/canva/canva-original.svg", name:"Canva"},
                {src:"https://cdn.jsdelivr.net/gh/devicons/devicon/icons/vscode/vscode-original.svg", name:"VS Code"}
              ].map(tool => (
                <div key={tool.name} style={{
                  padding:20,
                  background:"#F8F9FA",
                  borderRadius:12,
                  display:"flex",
                  flexDirection:"column",
                  alignItems:"center",
                  gap:12,
                  transition:"all 0.3s",
                  border:"2px solid #E9ECEF"
                }}
                onMouseEnter={e => {
                  e.currentTarget.style.background="#FFF";
                  e.currentTarget.style.transform="translateY(-4px)";
                  e.currentTarget.style.borderColor="#00897B";
                }}
                onMouseLeave={e => {
                  e.currentTarget.style.background="#F8F9FA";
                  e.currentTarget.style.transform="translateY(0)";
                  e.currentTarget.style.borderColor="#E9ECEF";
                }}>
                  <img 
                    src={tool.src} 
                    alt={tool.name}
                    style={{
                      width:isMobile?32:40,
                      height:isMobile?32:40,
                      objectFit:"contain"
                    }}
                  />
                  {!isMobile && (
                    <span style={{
                      fontSize:12,
                      color:"#6C757D",
                      fontWeight:500,
                      textAlign:"center"
                    }}>
                      {tool.name}
                    </span>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Work Experience - keeping existing structure with light theme */}
      <section id="work" style={{ 
        padding:isMobile?"80px 20px":"120px 48px",
        background:"#FFFFFF"
      }}>
        <div style={{ maxWidth:1000, margin:"0 auto" }}>
          <SectionLabel>Work Experience</SectionLabel>

          <div style={{ position:"relative", marginTop:48 }}>
            {!isMobile && (
              <div style={{
                position:"absolute",
                left:0,
                top:0,
                bottom:0,
                width:3,
                background:"linear-gradient(to bottom, #00897B, transparent)"
              }}/>
            )}

            {timeline.map((item, i) => (
              <div key={i} style={{
                paddingLeft:isMobile?0:48,
                paddingBottom:i < timeline.length - 1 ? 56 : 0,
                position:"relative"
              }}>
                {!isMobile && (
                  <>
                    <div style={{
                      position:"absolute",
                      left:-9,
                      top:8,
                      width:20,
                      height:20,
                      borderRadius:"50%",
                      background:"#00897B",
                      border:"4px solid #FFF",
                      boxShadow:"0 0 0 4px #E7F5F4"
                    }}/>
                    <div style={{
                      position:"absolute",
                      left:32,
                      top:12,
                      padding:"4px 12px",
                      background:"#E7F5F4",
                      borderRadius:6,
                      border:"2px solid #B2DFDB"
                    }}>
                      <span style={{
                        fontSize:12,
                        fontWeight:600,
                        color:"#00897B",
                        whiteSpace:"nowrap"
                      }}>
                        {item.year}
                      </span>
                    </div>
                  </>
                )}

                {isMobile && (
                  <div style={{
                    display:"inline-block",
                    padding:"4px 12px",
                    background:"#E7F5F4",
                    borderRadius:6,
                    marginBottom:12,
                    border:"2px solid #B2DFDB"
                  }}>
                    <span style={{
                      fontSize:12,
                      fontWeight:600,
                      color:"#00897B"
                    }}>
                      {item.year}
                    </span>
                  </div>
                )}

                <div style={{
                  background:"#F8F9FA",
                  borderRadius:16,
                  padding:isMobile?24:32,
                  border:"2px solid #E9ECEF",
                  marginTop:isMobile?0:48
                }}>
                  <h4 style={{
                    fontSize:22,
                    fontWeight:700,
                    color:"#1A1A1A",
                    marginBottom:8
                  }}>
                    {item.title}
                  </h4>

                  <p style={{
                    fontSize:16,
                    color:"#00897B",
                    fontWeight:600,
                    marginBottom:16
                  }}>
                    {item.place}
                  </p>

                  <p style={{
                    fontSize:15,
                    color:"#495057",
                    lineHeight:1.7,
                    marginBottom:20
                  }}>
                    {item.desc}
                  </p>

                  <div style={{
                    display:"flex",
                    gap:8,
                    flexWrap:"wrap"
                  }}>
                    {item.skills.map(skill => (
                      <span key={skill} style={{
                        padding:"6px 12px",
                        background:"#E7F5F4",
                        color:"#00897B",
                        borderRadius:6,
                        fontSize:12,
                        fontWeight:600
                      }}>
                        {skill}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div style={{ marginTop:64 }}>
            <h3 style={{
              fontSize:24,
              fontWeight:700,
              color:"#1A1A1A",
              marginBottom:32
            }}>
              Education
            </h3>

            <div style={{
              display:"grid",
              gridTemplateColumns:isMobile?"1fr":"repeat(3, 1fr)",
              gap:24
            }}>
              {education.map((item, i) => (
                <div key={i} style={{
                  background:"#F8F9FA",
                  borderRadius:16,
                  padding:24,
                  border:"2px solid #E9ECEF",
                  position:"relative",
                  overflow:"hidden"
                }}>
                  <div style={{
                    position:"absolute",
                    top:16,
                    right:16,
                    padding:"4px 10px",
                    background:item.badge==="PURSUING"
                      ?"#FFF3CD"
                      :item.badge==="COMPLETED"
                      ?"#D4EDDA"
                      :"#E7F5F4",
                    borderRadius:6,
                    border:`2px solid ${
                      item.badge==="PURSUING"
                      ?"#FFC107"
                      :item.badge==="COMPLETED"
                      ?"#28A745"
                      :"#00897B"
                    }`
                  }}>
                    <span style={{
                      fontSize:10,
                      fontWeight:700,
                      color:item.badge==="PURSUING"
                        ?"#856404"
                        :item.badge==="COMPLETED"
                        ?"#155724"
                        :"#00897B",
                      letterSpacing:0.5
                    }}>
                      {item.badge}
                    </span>
                  </div>

                  <div style={{
                    fontSize:12,
                    fontWeight:600,
                    color:"#00897B",
                    marginBottom:12
                  }}>
                    {item.year}
                  </div>

                  <h4 style={{
                    fontSize:18,
                    fontWeight:700,
                    color:"#1A1A1A",
                    marginBottom:8,
                    paddingRight:60
                  }}>
                    {item.degree}
                  </h4>

                  <p style={{
                    fontSize:14,
                    color:"#6C757D",
                    marginBottom:12,
                    lineHeight:1.5
                  }}>
                    {item.field}
                  </p>

                  <p style={{
                    fontSize:13,
                    color:"#ADB5BD",
                    lineHeight:1.4,
                    marginBottom:12
                  }}>
                    {item.institution}
                  </p>

                  {item.focus && (
                    <p style={{
                      fontSize:12,
                      color:"#868E96",
                      lineHeight:1.5,
                      fontStyle:"italic"
                    }}>
                      {item.focus}
                    </p>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Projects Section with Tabs */}
      <section id="projects" style={{ 
        padding:isMobile?"80px 20px":"120px 48px",
        background:"#F8F9FA"
      }}>
        <div style={{ maxWidth:1400, margin:"0 auto" }}>
          <SectionLabel>Featured Work</SectionLabel>
          
          <p style={{
            fontSize:18,
            color:"#6C757D",
            marginBottom:40,
            marginTop:16
          }}>
            Product design work that delivers real business impact
          </p>

          {/* Project Tabs */}
          <div style={{
            display:"flex",
            gap:16,
            marginBottom:48,
            flexWrap:"wrap"
          }}>
            {[
              {id:"websites", label:"Websites & Design"},
              {id:"brand", label:"Logos & Posters"}
            ].map(tab => (
              <button
                key={tab.id}
                onClick={() => setProjectTab(tab.id)}
                style={{
                  padding:"12px 32px",
                  background:projectTab === tab.id ? "#00897B" : "#FFF",
                  color:projectTab === tab.id ? "#FFF" : "#6C757D",
                  border:"2px solid",
                  borderColor:projectTab === tab.id ? "#00897B" : "#E9ECEF",
                  borderRadius:8,
                  fontFamily:"'Inter', sans-serif",
                  fontSize:15,
                  fontWeight:600,
                  cursor:"pointer",
                  transition:"all 0.3s"
                }}
                onMouseEnter={e => {
                  if(projectTab !== tab.id) {
                    e.currentTarget.style.borderColor="#00897B";
                    e.currentTarget.style.color="#00897B";
                  }
                }}
                onMouseLeave={e => {
                  if(projectTab !== tab.id) {
                    e.currentTarget.style.borderColor="#E9ECEF";
                    e.currentTarget.style.color="#6C757D";
                  }
                }}>
                {tab.label}
              </button>
            ))}
          </div>

          {/* Websites & Design Projects */}
          {projectTab === "websites" && (
            <div style={{
              display:"grid",
              gridTemplateColumns:isMobile?"1fr":"repeat(2, 1fr)",
              gap:32
            }}>
              {websiteProjects.map(project => (
                <ProjectCard 
                  key={project.id}
                  project={project}
                  onClick={() => onSelectProject(project)}
                  isMobile={isMobile}
                />
              ))}
            </div>
          )}

          {/* Brand Identity - Logos & Posters */}
          {projectTab === "brand" && (
            <div>
              <div style={{
                background:"#FFF",
                borderRadius:16,
                padding:isMobile?24:40,
                border:"2px solid #E9ECEF",
                marginBottom:32
              }}>
                <h3 style={{
                  fontSize:28,
                  fontWeight:700,
                  color:"#1A1A1A",
                  marginBottom:16
                }}>
                  Brand Identity Design
                </h3>
                <p style={{
                  fontSize:16,
                  color:"#6C757D",
                  lineHeight:1.7,
                  marginBottom:24
                }}>
                  Creating distinctive brand identities across diverse industries. Each project showcases comprehensive brand design from concept to real-world application, ensuring consistency across both digital and physical touchpoints.
                </p>
                <div style={{
                  display:"flex",
                  gap:12,
                  flexWrap:"wrap"
                }}>
                  <a
                    href="https://www.behance.net/gopikakrishvfc"
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      padding:"12px 24px",
                      background:"linear-gradient(135deg, #00BFA5 0%, #00897B 100%)",
                      color:"#FFF",
                      borderRadius:8,
                      textDecoration:"none",
                      fontFamily:"'Inter', sans-serif",
                      fontSize:14,
                      fontWeight:600,
                      display:"inline-flex",
                      alignItems:"center",
                      gap:8,
                      transition:"all 0.3s"
                    }}
                    onMouseEnter={e => e.currentTarget.style.transform="translateY(-2px)"}
                    onMouseLeave={e => e.currentTarget.style.transform="translateY(0)"}>
                    View Full Portfolio on Behance
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/>
                      <polyline points="15 3 21 3 21 9"/>
                      <line x1="10" y1="14" x2="21" y2="3"/>
                    </svg>
                  </a>
                </div>
              </div>

              <div style={{
                display:"grid",
                gridTemplateColumns:isMobile?"1fr":"repeat(3, 1fr)",
                gap:24
              }}>
                {brandIdentityWork.map(item => (
                  <BrandCard key={item.id} item={item} isMobile={isMobile} />
                ))}
              </div>
            </div>
          )}
        </div>
      </section>

      {/* Contact Section - keeping existing but light theme */}
      <section id="contact" style={{ 
        padding:isMobile?"80px 20px":"120px 48px",
        background:"#FFFFFF"
      }}>
        <div style={{ maxWidth:800, margin:"0 auto" }}>
          <div style={{ textAlign:"center", marginBottom:48 }}>
            <SectionLabel>Let's Work Together</SectionLabel>
            <h2 style={{
              fontSize:isMobile?32:40,
              fontWeight:700,
              color:"#1A1A1A",
              marginTop:16,
              marginBottom:16
            }}>
              Have a Project in Mind?
            </h2>
            <p style={{
              fontSize:16,
              color:"#6C757D",
              lineHeight:1.8
            }}>
              Let's discuss how I can help solve your design challenges and create products that users love.
            </p>
          </div>

          <div style={{
            background:"#F8F9FA",
            borderRadius:16,
            padding:isMobile?32:48,
            border:"2px solid #E9ECEF"
          }}>
            <form onSubmit={handleSubmit}>
              <div style={{
                display:"grid",
                gridTemplateColumns:isMobile?"1fr":"repeat(2, 1fr)",
                gap:24,
                marginBottom:24
              }}>
                <div>
                  <label style={{
                    display:"block",
                    fontSize:14,
                    fontWeight:600,
                    color:"#1A1A1A",
                    marginBottom:8
                  }}>
                    Your Name
                  </label>
                  <input 
                    type="text"
                    name="from_name"
                    required
                    style={{
                      width:"100%",
                      padding:"14px 16px",
                      background:"#FFF",
                      border:"2px solid #E9ECEF",
                      borderRadius:8,
                      fontSize:15,
                      color:"#1A1A1A",
                      fontFamily:"'Inter', sans-serif",
                      outline:"none",
                      transition:"all 0.3s"
                    }}
                    onFocus={e => e.currentTarget.style.borderColor="#00897B"}
                    onBlur={e => e.currentTarget.style.borderColor="#E9ECEF"}
                  />
                </div>

                <div>
                  <label style={{
                    display:"block",
                    fontSize:14,
                    fontWeight:600,
                    color:"#1A1A1A",
                    marginBottom:8
                  }}>
                    Your Email
                  </label>
                  <input 
                    type="email"
                    name="from_email"
                    required
                    style={{
                      width:"100%",
                      padding:"14px 16px",
                      background:"#FFF",
                      border:"2px solid #E9ECEF",
                      borderRadius:8,
                      fontSize:15,
                      color:"#1A1A1A",
                      fontFamily:"'Inter', sans-serif",
                      outline:"none",
                      transition:"all 0.3s"
                    }}
                    onFocus={e => e.currentTarget.style.borderColor="#00897B"}
                    onBlur={e => e.currentTarget.style.borderColor="#E9ECEF"}
                  />
                </div>
              </div>

              <div style={{ marginBottom:24 }}>
                <label style={{
                  display:"block",
                  fontSize:14,
                  fontWeight:600,
                  color:"#1A1A1A",
                  marginBottom:8
                }}>
                  Project Details
                </label>
                <textarea 
                  name="message"
                  rows={6}
                  required
                  placeholder="Tell me about your project, timeline, and goals..."
                  style={{
                    width:"100%",
                    padding:"14px 16px",
                    background:"#FFF",
                    border:"2px solid #E9ECEF",
                    borderRadius:8,
                    fontSize:15,
                    color:"#1A1A1A",
                    fontFamily:"'Inter', sans-serif",
                    outline:"none",
                    resize:"vertical",
                    transition:"all 0.3s"
                  }}
                  onFocus={e => e.currentTarget.style.borderColor="#00897B"}
                  onBlur={e => e.currentTarget.style.borderColor="#E9ECEF"}
                />
              </div>

              <button
                type="submit"
                disabled={submitStatus==="sending"}
                style={{
                  width:"100%",
                  padding:"16px 32px",
                  background:submitStatus==="success"
                    ?"#28A745"
                    :submitStatus==="error"
                    ?"#DC3545"
                    :"linear-gradient(135deg, #00BFA5 0%, #00897B 100%)",
                  color:"#FFF",
                  border:"none",
                  borderRadius:8,
                  fontSize:16,
                  fontWeight:600,
                  cursor:submitStatus==="sending"?"not-allowed":"pointer",
                  transition:"all 0.3s",
                  fontFamily:"'Inter', sans-serif",
                  display:"flex",
                  alignItems:"center",
                  justifyContent:"center",
                  gap:8,
                  boxShadow:"0 4px 12px rgba(0, 137, 123, 0.3)",
                  opacity:submitStatus==="sending"?0.7:1
                }}
                onMouseEnter={e => {
                  if(submitStatus!=="sending") {
                    e.currentTarget.style.transform="translateY(-2px)";
                    e.currentTarget.style.boxShadow="0 6px 20px rgba(0, 137, 123, 0.4)";
                  }
                }}
                onMouseLeave={e => {
                  e.currentTarget.style.transform="translateY(0)";
                  e.currentTarget.style.boxShadow="0 4px 12px rgba(0, 137, 123, 0.3)";
                }}>
                {submitStatus==="sending" && "Sending..."}
                {submitStatus==="success" && "Message Sent Successfully!"}
                {submitStatus==="error" && "Failed to Send - Please Try Again"}
                {!submitStatus && (
                  <>
                    Send Message
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <line x1="22" y1="2" x2="11" y2="13"/>
                      <polygon points="22 2 15 22 11 13 2 9 22 2"/>
                    </svg>
                  </>
                )}
              </button>
            </form>
          </div>
        </div>
      </section>

      <Footer />

      <style>{`
        @keyframes blink { 0%, 100% { opacity: 1; } 50% { opacity: 0; } }
        @keyframes spin { from { transform: rotate(0deg); } to { transform: rotate(360deg); } }
        @keyframes float { 0%, 100% { transform: translateY(0); } 50% { transform: translateY(-10px); } }
        * { box-sizing: border-box; margin: 0; padding: 0; }
        html { scroll-behavior: smooth; }
        input::placeholder, textarea::placeholder { color: #ADB5BD; }
      `}</style>
    </div>
  );
}

export default function App() {
  const [currentProject, setCurrentProject] = useState(null);

  const handleSelect = (p) => { 
    setCurrentProject(p); 
    window.scrollTo({top:0, behavior:"smooth"}); 
  };
  
  const handleBack = () => { 
    setCurrentProject(null); 
    setTimeout(() => document.getElementById("projects")?.scrollIntoView({behavior:"smooth"}), 100); 
  };
  
  const handleNext = () => { 
    const idx = websiteProjects.findIndex(p => p.id === currentProject.id); 
    setCurrentProject(websiteProjects[(idx + 1) % websiteProjects.length]); 
    window.scrollTo({top:0, behavior:"smooth"}); 
  };
  
  const nextProject = currentProject 
    ? websiteProjects[(websiteProjects.findIndex(p => p.id === currentProject.id) + 1) % websiteProjects.length] 
    : null;

  return currentProject
    ? <ProjectPage project={currentProject} onBack={handleBack} onNext={handleNext} nextProject={nextProject} />
    : <HomePage onSelectProject={handleSelect} />;
}